<template>
    <label
        class="inline-flex items-center justify-center cursor-pointer gap-2.5 text-xsss sm:text-xs hover:text-brand-2-950"
    >
        <p
            class="min-w-[36px] sm:min-w-[41px] lh-transition"
            :class="{ 'font-semibold text-brand-2-950': type == 'stays' }"
        >
            Stays
        </p>
        <div class="-top-0.5 sm:top-0 relative">
            <input
                type="checkbox"
                class="sr-only peer"
                name="type"
                value="weddings"
                :checked="type == 'weddings'"
                @change="toggleType"
            >
            <div
                class="relative w-[30px] h-[16px] bg-brand-2-950 peer-focus:outline-hidden rounded-full peer peer-checked:after:translate-x-full peer-checked:rtl:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-px after:start-px after:bg-white after:rounded-full after:size-[14px] after:transition-all">
            </div>
        </div>
        <p
            class="min-w-[64px] sm:min-w-[73px] lh-transition"
            :class="{ 'font-semibold text-brand-2-950': type == 'weddings' }"
        >
            Weddings
        </p>
    </label>
</template>

<script setup>
    const props = defineProps([
        'type',
    ]);

    const emits = defineEmits(['update:type']);

    function toggleType($event) {
        emits('update:type', $event.target.checked ? 'weddings' : 'stays');
    }
</script>
